import React from "react";
import "./privacypolicy.css";

const PrivacyPolicy = () => {
   return (
    <div className="privacy-page-container">

      <div className="privacy-card header-card">
        <h1>Privacy Policy</h1>
      </div>

      <div className="privacy-card">
        <h2>I. Name and Address of the Responsible Party</h2>
        <p>
          Responsible in the sense of the General Data Protection Regulation and other national data protection laws of the member states as well as other data protection regulations is the:
        </p>
        <p><strong>Universität Duisburg-Essen</strong></p>
        <p><strong>Campus Duisburg:</strong><br />
          Forsthausweg 2<br />
          47057 Duisburg<br />
          Tel.: +49 203 37-90<br />
          Fax.: +49 203 37-93333</p>
        <p><strong>Campus Essen:</strong><br />
          Universitätsstraße 2<br />
          45141 Essen<br />
          Tel.: +49 201 18-30<br />
          Fax.: +49 201 18-33536</p>
        <p>Website: <a href="https://www.uni-due.de" target="_blank" rel="noopener noreferrer">www.uni-due.de</a></p>
        <p>The University of Duisburg-Essen is represented by its Rector:</p>
        <p>
          <strong>Prof. Dr. Barbara Albert</strong><br />
          <a href="mailto:rektorin@uni-due.de">rektorin@uni-due.de</a><br />
          Campus Duisburg: Tel.: +49 203 37-90<br />
          Campus Essen: Tel.: +49 201 18-30<br />
          Website: <a href="https://www.uni-due.de/de/rektorat/" target="_blank" rel="noopener noreferrer">
            www.uni-due.de/de/rektorat/
          </a>
        </p>
      </div>

      <div className="privacy-card">
        <h2>II. Name and Address of the Data Protection Officer</h2>
        <p>
          The data protection officer of the responsible party is:</p>
        <p>
          <strong>Dr. Kai-Uwe Loser</strong><br />
          (Official Data Protection Officer of the University of Duisburg-Essen)<br />
          Forsthausweg 2<br />
          47057 Duisburg<br />
          Tel.: +49 234 32 28720<br />
          <a href="mailto:kai-uwe.loser@uni-due.de">kai-uwe.loser@uni-due.de</a><br />
          Website: <a
            href="https://www.uni-due.de/verwaltung/datenschutz"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.uni-due.de/verwaltung/datenschutz
          </a>
        </p>
      </div>

      <div className="privacy-card">
        <h2>III. General Information on Data Processing</h2>

        <h3>1. Scope of the Processing of Personal Data</h3>
        <p>
          We process personal data of our users basically only to the extent necessary to provide a functional website as well as our content and services. The processing of personal data of our users regularly takes place only after consent of the users. An exception applies in cases where prior obtaining of consent is not possible for factual reasons and the processing of the data is permitted by legal regulations.
        </p>

        <h3>2. Legal Basis for the Processing of Personal Data</h3>
        <p>
          To the extent that we obtain consent from the data subject for processing operations of personal data, Art. 6 para. 1 lit. a EU General Data Protection Regulation (GDPR) serves as the legal basis.
          <br /><br />
          In the processing of personal data that is necessary for the performance of a contract to which the data subject is a party, Art. 6 para. 1 lit. b GDPR serves as the legal basis.
          <br /><br />
          To the extent that processing of personal data is necessary for compliance with a legal obligation to which we are subject, Art. 6 para. 1 lit. c GDPR serves as the legal basis.
          <br /><br />
          In the event that vital interests of the data subject or another natural person make processing of personal data necessary, Art. 6 para. 1 lit. d GDPR serves as the legal basis.
          <br /><br />
          If the processing is necessary for the performance of a task carried out in the public interest or in the exercise of official authority vested in us, Art. 6 para. 1 lit. e GDPR serves as the legal basis.
        </p>

        <h3>3. Data Deletion and Storage Duration</h3>
        <p>
          The personal data of the data subject will be deleted or blocked as soon as the purpose of storage ceases. Storage may take place beyond this if this is provided for by the European or national legislator in Union regulations, laws or other provisions to which we are subject. Blocking or deletion of the data also takes place when a storage period prescribed by the aforementioned norms expires, unless there is a necessity for further storage of the data for the conclusion of a contract or fulfillment of the contract.
        </p>
      </div>

      <div className="privacy-card">
        <h2>IV. Provision of the Website and Creation of Log Files</h2>

        <h3>1. Description and Scope of Data Processing</h3>
        <p>
          With every call of our website, our system automatically collects data and information from the computer system of the calling computer.
          <br /><br />
          The following data is collected in this process:
        </p>
        <ul>
          <li>Information about the browser type and the version used</li>
          <li>The operating system of the users</li>
          <li>The IP address of the users</li>
          <li>Origin of the website access (organization, country, city)</li>
          <li>The internet service provider of the users</li>
          <li>Websites that are accessed in our system</li>
          <li>Date and time of access</li>
          <li>Duration of stay</li>
          <li>Websites from which the users' system reaches our website</li>
        </ul>
        <p>
          Storage of this data together with other personal data of the users does not take place. Accordingly, no personal information is stored.
        </p>

        <h3>2. Legal Basis</h3>
        <p>Legal basis for the temporary storage of the data and the log files is Art. 6 para. 1 lit. e GDPR.</p>

        <h3>3. Purpose of Data Processing</h3>
        <p>
          The temporary storage of the IP address by the system is necessary to enable delivery of the website to the users' computer. For this, the IP address of the users must remain stored for the duration of the session.
        </p>
        <p>
          Storage in log files takes place to ensure the functionality of the website. In addition, the data serves us to optimize the website and to ensure the security of our information technology systems. Evaluation of the data for marketing purposes does not take place in this context.
        </p>
        <p>
          In these purposes lies also our legitimate interest in data processing according to Art. 6 para. 1 lit. e GDPR.
        </p>

        <h3>4. Duration of Storage</h3>
        <p>
          The data is deleted as soon as it is no longer required for the achievement of the purpose of its collection. In the case of the collection of data for the provision of the website, this is the case when the respective session is ended.
        </p>

        <h3>5. Possibility of Objection and Elimination</h3>
        <p>
          The collection of the data is absolutely necessary for the operation of the website. No objection possible.
        </p>
      </div>

      <div className="privacy-card">
        <h2>V. Use of Cookies</h2>

        <h3>1. Description and Scope</h3>
        <p>
          Our websites use so-called session cookies. Session cookies are small units of information that a provider stores in the RAM of the visitors' computer. A randomly generated unique identification number, a so-called session ID, is stored in a session cookie. In addition, a cookie contains information about its origin and storage period. These cookies cannot store other data.
        </p>
        <p>
          (There are also permanent cookies to recognize visitors even after a long time. This information is then stored as a text file on the hard disk of the visitors' computer. In contrast, the session cookies used by us are deleted when you end the session.)
        </p>

        <h3>2. Legal Basis</h3>
        <p>The legal basis for the processing of personal data using cookies is Art. 6 para. 1 lit. e GDPR.</p>

        <h3>3. Purpose</h3>
        <p>
          The purpose of using technically necessary cookies is to simplify the use of websites for users. Some functions of our website cannot be offered without the use of cookies. For these, it is necessary that the browser is recognized even after a page change.
        </p>
        <p>
          The user data collected through technically necessary cookies is not used to create user profiles.
        </p>

        <h3>4. Duration of Storage</h3>
        <p>The session cookies used by us are necessary for the function of our website and are deleted when you end the session.</p>
      </div>

      <div className="privacy-card">
        <h2>VI. Newsletter / Dispatch of Press Information</h2>
        <p>
          Does not apply to the websites we maintain. Further information can be found in the central data protection information of the UDE:
          <a href="https://www.uni-due.de">Link to UDE</a>
        </p>
      </div>

      <div className="privacy-card">
        <h2>VII. Contact Forms and Registration Forms</h2>
        <h3>1. Description and Scope of Data Processing</h3>

        <p>We use the open-source software tool Matomo (https://matomo.org) on our website, in the on-premise variant (i.e. exclusively on our servers), to analyze the surfing behavior of our users. The software reads, among other things, the so-called HTTP-User-Agent-String. When individual pages of our website are called, the following data is collected:</p>

        <p>At the time of sending the message, the following data is additionally stored:</p>

        <ul>
          <li>Date and time of the message</li>
        </ul>

        <p>
          For the processing of the data, your consent is obtained during the sending process and reference is made to this privacy policy.
        </p>

        <p>
          In this context, no data is passed on to third parties. The data is used exclusively for processing the respective conversation.
        </p>

        <h3>2. Legal Basis for Data Processing</h3>

        <p>The legal basis for the processing of the data is Art. 6 para. 1 lit. a GDPR in the case of consent from the users.</p>
        <p>The legal basis for the processing of the data transmitted in the course of sending an e-mail is Art. 6 para. 1 lit. e GDPR.</p>
        <p>If the e-mail contact aims at the conclusion of a contract, the additional legal basis for the processing is Art. 6 para. 1 lit. b GDPR.</p>

        <h3>3. Purpose of Data Processing</h3>
        <p>The processing of personal data from the input mask serves us solely to process the purpose specified in the form.</p>
        <p>
          The other personal data processed during the sending process serve to prevent misuse of the contact form and to ensure the security of our information technology systems.
        </p>

        <h3>4. Duration of Storage</h3>
        <p>
          The data is deleted as soon as it is no longer required for the achievement of the purpose of its collection. For general contact forms, this is the case when the respective conversation with the user is ended. For registration forms after completion of the registration phase and assignment of all applicants. In the case of a study place application, storage takes place for up to 12 months after the acceptance or rejection date.
        </p>

        <h3>5. Possibility of Objection and Elimination</h3>
        <p>
          The users have the possibility at any time to revoke their consent to the processing of personal data. If users contact us by e-mail, they can object to the storage of their personal data at any time. In such a case, the conversation cannot be continued.
        </p>
        <p>All personal data stored in the course of contacting us will be deleted in this case.</p>
      </div>

      <div className="privacy-card">
        <h2>VIII. Web Analysis by Matomo</h2>

          <h3>1. Scope of the Processing of Personal Data</h3>
          <p>
            We use the open-source software tool Matomo (https://matomo.org) on our website, in the on-premise variant (i.e. exclusively on our servers), to analyze the surfing behavior of our users. The software reads, among other things, the so-called HTTP-User-Agent-String. When individual pages of our website are called, the following data is collected:
          </p>
          <ul>
            <li>Information about the browser type and the version used</li>
            <li>The operating system of the users</li>
            <li>The IP address of the users, resulting in:</li>
              <ul>
                <li>Origin of the website access (organization, country, city)</li>
                <li>The internet service provider of the users</li>
              </ul>
            <li>Date and time of access</li>
            <li>Websites that are accessed in our system.</li>
            <li>Duration of stay</li>
            <li>Websites from which the users' system reaches our website</li>
          </ul>
          <p>The software runs exclusively on our servers.</p>

          <h3>2. Legal Basis for the Processing of Personal Data</h3>
          <p>The legal basis for the processing of the personal data of the users is Art. 6 para. 1 lit. e GDPR.</p>

          <h3>3. Purpose of Data Processing</h3>
          <p>
            The processing of the personal data of the users enables us to analyze the surfing behavior of our users. Through the evaluation of the collected data, we are able to compile information about the use of the individual components of our website. This helps us to continuously improve our website and its user-friendliness. Our legitimate interest in the processing of the data pursuant to Art. 6 para. 1 lit. e GDPR also lies in these purposes. By anonymizing the IP address, the users' interest in the protection of their personal data is sufficiently taken into account.
          </p>

          <h3>4. Duration of Storage</h3>
          <p>Matomo stores the data exclusively in anonymized form and for statistical purposes. A personal evaluation is not possible.</p>

          <h3>5. Objection to Data Collection</h3>
          <p>
            Even if the principles of data minimization and anonymization are fulfilled, you additionally have the option to activate the "Do-Not-Track" option in your browser to prevent tracking anyway. Alternatively, you can deactivate tracking for our pages via a special cookie in the following dialog.
          </p>

      </div>

      <div className="privacy-card">
        <h2>IX. Third-Party Services</h2>

        <h3>1. Social Media Activities</h3>
        <p>In our web offering, we refer to our social media channels with the following providers:</p>
        <ul>
          <li>Facebook</li>
          <li>Twitter</li>
          <li>Instagram</li>
          <li>Youtube</li>
          <li>Flickr</li>
          <li>XING</li>
          <li>LinkedIn</li>
        </ul>

        <p>
          Accessing these channels requires that the providers of these contents perceive the IP address of the users, since without the IP address no content can be sent to the browser of the respective users. The IP address is therefore necessary for the display of these contents. We have no influence on whether and how third-party providers store and use IP addresses.
        </p>

        <ul>
        <li>
          <strong>Privacy Policy at Facebook:</strong><br />
          <a href="https://www.facebook.com/privacy/explanation" target="_blank" rel="noopener noreferrer">
            https://www.facebook.com/privacy/explanation
          </a>
        </li>
        <li>
          <strong>Privacy Policy at X (formerly Twitter):</strong><br />
          <a href="https://twitter.com/de/privacy" target="_blank" rel="noopener noreferrer">
            https://twitter.com/de/privacy
          </a>
        </li>
        <li>
          <strong>Privacy Policy at Instagram:</strong><br />
          <a href="https://help.instagram.com/519522125107875" target="_blank" rel="noopener noreferrer">
            https://help.instagram.com/519522125107875
          </a>
        </li>
        <li>
          <strong>Privacy Policy at YouTube:</strong><br />
          <a href="https://policies.google.com/privacy?hl=de&gl=de" target="_blank" rel="noopener noreferrer">
            https://policies.google.com/privacy?hl=de&gl=de
          </a>
        </li>
        <li>
          <strong>Privacy Policy at Flickr:</strong><br />
          <a href="https://www.flickr.com/help/privacy" target="_blank" rel="noopener noreferrer">
            https://www.flickr.com/help/privacy
          </a>
        </li>
        <li>
          <strong>Privacy Policy at XING:</strong><br />
          <a href="https://www.xing.com/privacy" target="_blank" rel="noopener noreferrer">
            https://www.xing.com/privacy
          </a>
        </li>
        <li>
          <strong>Privacy Policy at LinkedIn:</strong><br />
          <a href="https://www.linkedin.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">
            https://www.linkedin.com/legal/privacy-policy
          </a>
        </li>
        </ul>

        <h3>2. Embedding of YouTube Videos</h3>
        <p>
          It may happen that YouTube videos are embedded within the web offering. This usually requires that the providers of these contents perceive the IP address of the users, since without the IP address no content can be sent to the browser of the respective user. The IP address is therefore necessary for the display of these contents. We have no influence on whether and how third-party providers store IP addresses.
          </p>
        <p>
          You can find the privacy policy for the use of YouTube at:<br />
          <a href="https://policies.google.com/privacy?hl=de&gl=de" target="_blank" rel="noopener noreferrer">
            https://policies.google.com/privacy
          </a>
        </p>
      </div>
      
      <div className="privacy-card">
        <h2>X. Rights of the Data Subject</h2>

        <p>
          If personal data concerning you is processed, you are a data subject within the meaning of the GDPR and you have the following rights vis-à-vis the controller:
        </p>

        <h3>1. Right to Information</h3>
        <p>
          You can request confirmation from the controller as to whether personal data concerning you is processed by us.
        </p>
        <p>If such processing takes place, you can request information from the controller about the following:</p>
      
        <ol>
          <li>the purposes for which the personal data are processed;</li>
          <li>the categories of personal data which are processed;</li>
          <li>the recipients or categories of recipients to whom the personal data concerning you have been or will be disclosed;</li>
          <li>the planned duration of storage of the personal data concerning you or, if concrete information on this is not possible, criteria for determining the storage duration;</li>
          <li>the existence of a right to rectification or erasure of personal data concerning you, a right to restriction of processing by the controller or a right to object to this processing;</li>
          <li>the existence of a right to lodge a complaint with a supervisory authority;</li>
          <li>all available information about the origin of the data, if the personal data are not collected from the data subject;</li>
          <li>the existence of automated decision-making including profiling pursuant to Art. 22 para. 1 and 4 GDPR...</li>
        </ol>

        <p>
          You have the right to request information as to whether the personal data concerning you is transferred to a third country or to an international organization. In this context, you can request to be informed about the appropriate safeguards pursuant to Art. 46 GDPR in connection with the transfer.
        </p>

         <p>
          This right to information can be restricted to the extent that it is likely to make the realization of research or statistical purposes impossible or seriously impair it, and the restriction is necessary for the fulfillment of the research or statistical purposes.
        </p>

        <h3>2. Right to Rectification</h3>
        <p>
          You have the right to rectification and/or completion vis-à-vis the controller, provided that the processed personal data concerning you are incorrect or incomplete. The controller must make the rectification without undue delay.
        </p>

        <p>
          Your right to rectification can be restricted to the extent that it is likely to make the realization of research or statistical purposes impossible or seriously impair it, and the restriction is necessary for the fulfillment of the research or statistical purposes.
        </p>

        <h3>3. Right to Restriction of Processing</h3>
        <p>
          Under the following conditions, you can request the restriction of processing of personal data concerning you:
        </p>

        <ol>
          <li>If you contest the accuracy of the personal data concerning you, for a period enabling the controller to verify the accuracy of the personal data;</li>
          <li>The processing is unlawful and you oppose the erasure of the personal data and request instead the restriction of their use;</li>
          <li>The controller no longer needs the personal data for the purposes of processing, but you need them for the establishment, exercise or defense of legal claims;</li>
          <li>If you have objected to processing pursuant to Art. 21 para. 1 GDPR, as long as it has not yet been determined whether the legitimate grounds of the controller override your grounds.</li>
        </ol>
        
        <p>
         If the processing of personal data concerning you has been restricted, such data may – with the exception of storage – only be processed with your consent or for the establishment, exercise or defense of legal claims or for the protection of the rights of another natural or legal person or for reasons of important public interest of the Union or of a Member State.
        </p>

        <p>
          If the restriction of processing has been restricted under the above-mentioned conditions, you will be informed by the controller before the restriction is lifted.
        </p>

        <p>
          Your right to restriction of processing can be restricted to the extent that it is likely to make the realization of research or statistical purposes impossible or seriously impair it, and the restriction is necessary for the fulfillment of the research or statistical purposes.
        </p>

        <h3>4. Right to Erasure</h3>
        <h4>a) Obligation to Erase</h4>
        <p>You can request from the controller that the personal data concerning you be erased without undue delay, and the controller is obliged to erase such data without undue delay if one of the following reasons applies:</p>
        <ol>
          <li>The personal data concerning you are no longer necessary for the purposes for which they were collected or otherwise processed.</li>
          <li>You withdraw your consent on which the processing is based pursuant to Art. 6 para. 1 lit. a or Art. 9 para. 2 lit. a GDPR, and there is no other legal basis for the processing.</li>
          <li>You object to the processing pursuant to Art. 21 para. 1 GDPR and there are no overriding legitimate grounds for the processing, or you object to the processing pursuant to Art. 21 para. 2 GDPR.</li>
          <li>The personal data concerning you have been unlawfully processed.</li>
          <li>The erasure of personal data concerning you is necessary for compliance with a legal obligation under Union or Member State law to which the controller is subject.</li>
          <li>The personal data concerning you have been collected in relation to the offer of information society services pursuant to Art. 8 para. 1 GDPR.</li>
        </ol>

        <h4>b) Information to Third Parties</h4>

        <p>If the controller has made the personal data concerning you public and is obliged pursuant to Art. 17 para. 1 GDPR to erase them, it shall take reasonable steps, taking into account available technology and the cost of implementation, including technical measures, to inform controllers that are processing the personal data that you as the data subject have requested the erasure by such controllers of any links to, or copy or replication of, those personal data.</p>
        
        <h4>c) Exceptions</h4>
        <p>The right to erasure does not apply to the extent that processing is necessary</p>
        <ol>
          <li>for exercising the right of freedom of expression and information;</li>
          <li>for compliance with a legal obligation which requires processing by Union or Member State law to which the controller is subject, or for the performance of a task carried out in the public interest or in the exercise of official authority vested in the controller;</li>
          <li>for reasons of public interest in the area of public health in accordance with Art. 9 para. 2 lit. h and i and Art. 9 para. 3 GDPR;</li>
          <li>for archiving purposes in the public interest, scientific or historical research purposes or statistical purposes in accordance with Art. 89 para. 1 GDPR, to the extent that the right referred to in section a) is likely to render impossible or seriously impair the achievement of the objectives of that processing, or</li>
          <li>for the establishment, exercise or defense of legal claims.</li>
        </ol>

        <h3>5. Right to Notification</h3>
        <p>
          If you have exercised the right to rectification, erasure or restriction of processing vis-à-vis the controller, the controller is obliged to communicate any rectification or erasure of personal data or restriction of processing carried out to each recipient to whom the personal data have been disclosed, unless this proves impossible or involves disproportionate effort.
        </p>
        <p>
          You have the right vis-à-vis the controller to be informed about those recipients.
        </p>

        <h3>6. Right to Data Portability</h3>
        <p>You have the right to receive the personal data concerning you, which you have provided to the controller, in a structured, commonly used and machine-readable format. You also have the right to have those data transmitted to another controller without hindrance from the controller to which the personal data have been provided, provided that</p>

        <ol>
          <li>the processing is based on consent pursuant to Art. 6 para. 1 lit. a GDPR or Art. 9 para. 2 lit. a GDPR or on a contract pursuant to Art. 6 para. 1 lit. b GDPR and</li>
          <li>the processing is carried out by automated means.</li>
        </ol>

        <p>
          In exercising this right, you also have the right to have the personal data concerning you transmitted directly from one controller to another, where technically feasible. The rights and freedoms of others shall not be affected by this.
        </p>

        <p>
          The right to data portability does not apply to processing of personal data necessary for the performance of a task carried out in the public interest or in the exercise of official authority vested in the controller.
        </p>

        <h3>7. Right to Object</h3>
        <p>You have the right to object, on grounds relating to your particular situation, at any time to processing of personal data concerning you which is based on point (e) or (f) of Article 6(1) GDPR, including profiling based on those provisions.</p>
        <p>The controller shall no longer process the personal data unless the controller demonstrates compelling legitimate grounds for the processing which override your interests, rights and freedoms or for the establishment, exercise or defense of legal claims.</p>
        <p>If the personal data concerning you are processed for direct marketing purposes, you have the right to object at any time to processing of personal data concerning you for such marketing, which includes profiling to the extent that it is related to such direct marketing.</p>
        <p>If you object to processing for direct marketing purposes, the personal data concerning you will no longer be processed for such purposes.</p>
        <p>You have the possibility to exercise your right to object by automated means using technical specifications, in the context of the use of information society services, regardless of Directive 2002/58/EC.</p>
        <p>You also have the right to object, on grounds relating to your particular situation, to processing of personal data concerning you for scientific or historical research purposes or statistical purposes pursuant to Article 89(1) GDPR.</p>
        <p>Your right to object may be restricted to the extent that it is likely to render impossible or seriously impair the achievement of the research or statistical purposes, and the restriction is necessary for the fulfillment of the research or statistical purposes.</p>


        <h3>8. Right to Withdraw Consent</h3>
        <p>You have the right not to be subject to a decision based solely on automated processing, including profiling, which produces legal effects concerning you or similarly significantly affects you. This does not apply if the decision</p>

        <h3>9. Automated Individual Decision-Making Including Profiling</h3>
        <ol>
          <li>is necessary for entering into, or performance of, a contract between you and the controller,</li>
          <li>is authorized by Union or Member State law to which the controller is subject and which also lays down suitable measures to safeguard your rights and freedoms and legitimate interests; or</li>
          <li>is based on your explicit consent.</li>
        </ol>
        <p>
          However, such decisions may not be based on special categories of personal data referred to in Article 9(1) GDPR, unless Article 9(2)(a) or (g) GDPR applies and suitable measures to safeguard your rights and freedoms and legitimate interests are in place.
        </p>
        <p>
          In the cases referred to in points (1) and (3), the controller shall implement suitable measures to safeguard your rights and freedoms and legitimate interests, at least the right to obtain human intervention on the part of the controller, to express your point of view and to contest the decision.
        </p>

        <h3>10. Right to Lodge a Complaint with a Supervisory Authority</h3>
        <p>
          Without prejudice to any other administrative or judicial remedy, you have the right to lodge a complaint with a supervisory authority, in particular in the Member State of your habitual residence, place of work or place of the alleged infringement, if you consider that the processing of personal data relating to you infringes the GDPR.
        </p>

        <p>
          The supervisory authority with which the complaint has been lodged shall inform the complainant on the progress and the outcome of the complaint including the possibility of a judicial remedy pursuant to Article 78 GDPR.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
